var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-28
 * @brief Alarm 컴포넌트
 * 1초당 rerandering 발생
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
// recoil state
import { userInfoLoginState } from "../../../recoil/userState";
//
import { langId } from "../../../recoil/langState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
function AlarmCount(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const langIds = useRecoilValue(langId);
    // props
    const setParentAlarmCount = props.setAlarmCount;
    const alarmCountReload = props.alarmCountReload;
    const setParentAlarmCountReload = props.setAlarmCountReload;
    //
    const [alarmCount, setAlarmCount] = useState(0);
    useEffect(() => {
        getAlarmCountUnRead();
    }, [alarmCountReload, langIds]);
    let timer = null;
    function getAlarmCountUnRead() {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/notice/unreadcount`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlarmCount(data.body);
                    setParentAlarmCount(data.body);
                    setParentAlarmCountReload(false);
                }
                else {
                }
            }
        });
    }
    useEffect(() => {
        timer = setInterval(() => {
            getAlarmCountUnRead();
        }, 60000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return _jsx("p", { children: alarmCount > 99 ? "99+" : alarmCount });
}
export default AlarmCount;
